export default __webpack_public_path__ + "static/media/sign-in-with-google.85ccb846.png";